import MUITableContainer, {
  TableContainerProps,
} from "@material-ui/core/TableContainer";

const TableContainer = (props: TableContainerProps) => (
  <MUITableContainer {...props}></MUITableContainer>
);

export default TableContainer;
